<template>
  <div id="container">
    <div id="title">
      <h1>Liste des modèles</h1>
    </div>
    <!-- TODO : AJOUTER TOKEN POUR EDITION MODELE -->
    <!-- + intégrer les docs pour pouvoir les éditer -->
    <div id="content">
      <div
        class="block-flat"
        v-if="userConnected && userConnected.roles.includes('ROLE_ADMIN')"
      >
        <b-row class="derniers-dossiers">
          <b-col cols="12" sm="12" md="12" lg="6" xl="6"> </b-col>
          <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6" class="right">
            <div class="search-bar"></div>
          </b-col>
          <b-col cols="12">
            <div class="list-model">
              <b-button
                :key="modele.id"
                v-for="modele in models"
                class="edition-modele"
                variant="outline-success"
                @click="editModele(modele.id)">
                {{ modele.libelle }}
                <font-awesome-icon icon="pencil-alt"></font-awesome-icon>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import Vue from "vue";
import router from "../router/index.js";
export default {
  name: "Modeles",
  data: () => ({
    models: [],
  }),
  components: {},
  methods: {
    editModele(idModele) {
      let url = window.urlapi + 'edit-modele/' + idModele;

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + window.$cookies.get("token-sudthd")
        }
      })
      .then(async (response) => {
        if (!response.ok) {
          const text = await response.text();
          throw new Error(`Erreur ${response.status} : ${text}`);
        }
        return response.text();
      })
      .then((html) => {
        const newWindow = window.open();
        if (newWindow) {
          newWindow.document.open();
          newWindow.document.write(html);
          newWindow.document.close();
        } else {
          Vue.prototype.$awn.alert("Impossible d'ouvrir une nouvelle fenêtre.");
        }
      })
      .catch((error) => {
        console.error("Erreur lors de l'ouverture du modèle :", error);
        Vue.prototype.$awn.alert("Erreur lors de l'ouverture du modèle : " + error.message, {
          position: "bottom-right",
          timeout: 5000,
        });
      });
    },
    ...Vuex.mapActions("User", ["getUsers", "deleteUser"]),
  },
  computed: {
    ...Vuex.mapGetters("User", ["users", "pagination"]),
    ...Vuex.mapGetters("Authentification", ["userConnected"]),
  },
  mounted() {
    Vue.axios.get(window.urlapi + "modele").then((response) => {
      this.models = response.data.data;
    });
  },
};
</script>

<style></style>
